<template>
  <generic-modal
    size="small"
    :title="$t('api configuration')"
    icon="cogs"
    image="/images/icons/api.png"
    v-bind:scrolling="false"
    v-on:destroy="destroy"
    v-bind:on_finished="finished"
  >
    <div class="description">
      <div class="ui form">
        <h4 class="ui dividing header">{{ $t("token setup") }}</h4>
        <div class="fields">
          <div class="four wide field">
            <label for>{{ $t("validity time") }}</label>
            <input
              type="text"
              name="time_threshold"
              v-model="setup.validity_time"
            />
          </div>
          <div class="twelve wide field">
            <label for>{{ $t("security key") }}</label>
            <input type="text" name="key" v-model="setup.key" />
            <!-- <select
              ref="expire_time_dropdown"
              class="ui selection dropdown"
              name="time_threshold_unit"
              v-model="setup.expire_time_unit"
            >
              <option value="">{{ $t("select one") }}</option>
              <option value="hour">{{ $t("hour") }}</option>
              <option value="day">{{ $t("day") }}</option>
              <option value="week">{{ $t("week") }}</option>
              <option value="month">{{ $t("month") }}</option>
            </select> -->
          </div>
        </div>
        <div class="field">
          <label for>{{ $t("algorithm") }}</label>
          <div class="ui selection dropdown" ref="algorithm_dropdown">
            <input type="hidden" name="algorithm" />
            <i class="dropdown icon"></i>
            <div class="default text"></div>
            <div class="menu"></div>
          </div>
        </div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
// import { local_api, stringify } from "@/utils";
import GenericModal from "@/components/GenericModal";
import { local_api, error_toast } from "@/utils";
// import { v4 } from "uuid";

export default {
  name: "ApiManagerConfigurationModal",
  components: {
    "generic-modal": GenericModal,
  },
  computed: {},
  data() {
    return {
      setup: {
        validity_time: "1h",
        key: "",
        algorithm: "",
      },
    };
  },
  methods: {
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        local_api(vm, "post", "/api_manager/configuration/do-save", {
          s: vm.setup,
        })
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  mounted() {
    let vm = this;
    local_api(vm, "post", "/api_manager/configuration/do-get")
      .then((conf) => {
        // console.log(conf);
        if (conf) {
          Object.keys(conf).map((k) => {
            vm.setup[k] = conf[k];
          });

          if (conf.algorithm)
            window
              .jQuery(vm.$refs.algorithm_dropdown)
              .dropdown("set selected", conf.algorithm);

          // if (conf.expire_time_unit)
          //   window
          //     .jQuery(vm.$refs.expire_time_dropdown)
          //     .dropdown("set selected", conf.expire_time_unit);
        }
      })
      .catch((err) => {
        error_toast(err);
      });

    /** Algorithm */
    let vls = [
      { name: vm.$t("hmac using sha-256 hash algorithm"), value: "HS256" },
      { name: vm.$t("hmac using sha-384 hash algorithm"), value: "HS384" },
      { name: vm.$t("hmac using sha-512 hash algorithm"), value: "HS512" },
      {
        name: vm.$t("rsassa-pkcs1-v1_5 using sha-256 hash algorithm"),
        value: "RS256",
      },
      {
        name: vm.$t("rsassa-pkcs1-v1_5 using sha-384 hash algorithm"),
        value: "RS384",
      },
      {
        name: vm.$t("rsassa-pkcs1-v1_5 using sha-512 hash algorithm"),
        value: "RS512",
      },
      {
        name: vm.$t(
          "rsassa-pss using sha-256 hash algorithm (only node ^6.12.0 or >=8.0.0)",
        ),
        value: "PS256",
      },
      {
        name: vm.$t(
          "rsassa-pss using sha-384 hash algorithm (only node ^6.12.0 or >=8.0.0)",
        ),
        value: "PS384",
      },
      {
        name: vm.$t(
          "rsassa-pss using sha-512 hash algorithm (only node ^6.12.0 or >=8.0.0)",
        ),
        value: "PS512",
      },
      {
        name: vm.$t("ecdsa using p-256 curve and sha-256 hash algorithm"),
        value: "ES256",
      },
      {
        name: vm.$t("ecdsa using p-384 curve and sha-384 hash algorithm"),
        value: "ES384",
      },
      {
        name: vm.$t("ecdsa using p-521 curve and sha-512 hash algorithm"),
        value: "ES512",
      },
      {
        name: vm.$t("none"),
        value: "none",
      },
    ];
    window
      .jQuery(vm.$refs.algorithm_dropdown)
      .dropdown("setup menu", { values: vls })
      .dropdown({
        onChange(value) {
          vm.setup.algorithm = value;
        },
      });

    // window.jQuery(vm.$refs.expire_time_dropdown).dropdown();
  },
  watch: {},
  updated: function() {},
};
</script>
